import {getFirstSprite, isLipSyncAudioSpriteActiveInTrack} from 'powtoon-document/utils/trackSpriteUtils'
import {
  isSoundItem,
  isVideoItem,
  isImageHolderItemWithVideoContent
} from 'powtoon-document'

export const getVideoAssetTrackFromTracks = (tracks) => {
  if (!Array.isArray(tracks)) {throw Error('getVideoAssetTrackFromTracks missing tracks array')}

  return tracks.find((track) => {
    return isVideoItem(getFirstSprite(track))
  })
}

export const getAudioTracksTrackFromTracks = (tracks) => {
  if (!Array.isArray(tracks)) {throw Error('getAudioTracksTrackFromTracks missing tracks array')}

  return tracks.filter(isLipSyncAudioSpriteActiveInTrack)
}

export const getVideoAssetSpriteFromTracks = (tracks) => {
  const videoTrack = getVideoAssetTrackFromTracks(tracks)
  return videoTrack ?getFirstSprite(videoTrack): null
}

export const getPlaybackSettings = (data) => {
  if (!data) {
    throw Error('no input data in getPlaybackSettings')
  }

  return data.playbackSettings || getFirstSprite(data)?.playbackSettings
}

export const getVideoDuration = (manifestObject, contentItemId) => {
  const video = manifestObject?.videos?.[contentItemId] || manifestObject?.assets?.[contentItemId]
  return video?.videoData?.duration
}

export const getMediaAssetTrackFromTracks = (tracks) => {
  if (!Array.isArray(tracks)) {throw Error('getMediaAssetTrackFromTracks missing tracks array')}
  

  return tracks.find((track) => {
    const sprite = getFirstSprite(track)
    return isSoundItem(track) || isVideoItem(sprite) || isImageHolderItemWithVideoContent(sprite)
  })
}

export const getSoundLength = (manifestObject, contentItemId) => {
  const sound = manifestObject?.sounds?.[contentItemId]
  return sound?.length || 0
}

export const getVideoHolderTrackFromTracks = (tracks) => {
  if (!Array.isArray(tracks)) {throw Error('getVideoHolderTrackFromTracks missing tracks array')}

  return tracks.find((track) => {
    return isImageHolderItemWithVideoContent(getFirstSprite(track))
  })
}
